import { type PartData } from '../types.ts';

export const getNextMovie = (items: PartData[], partId: string | number): string | number | undefined => {
  const currentIndex = items.findIndex(item => item.id === partId);

  if (currentIndex === -1) {
    return undefined;
  }

  return items.at(currentIndex + 1)?.id;
};

export const getPrevMovie = (items: PartData[], partId: string | number): string | number | undefined => {
  const currentIndex = items.findIndex(item => item.id === partId);

  if (currentIndex === -1) {
    return undefined;
  }

  const prevIndex = currentIndex - 1;

  if (prevIndex < 0) {
    return undefined;
  }

  return items.at(prevIndex)?.id;
};
